export default {"src":"https://fishbrain.com/_next/static/media/washington.9234f1bd.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};